import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const ImagePlaceHolder = ({ hidden = false }) => (
  <div hidden={hidden} className="ph-item border-0 rounded-top img-fluid">
    <div className="ph-col-12 border-0">
      <div className="ph-picture rounded img-fluid" />
      <div className="ph-row">
        <div className="ph-col-6 big" />
        <div className="ph-col-4 empty big" />
        <div className="ph-col-2 big" />
        <div className="ph-col-4" />
        <div className="ph-col-8 empty" />
        <div className="ph-col-12  rounded-bottom" />
      </div>
    </div>
  </div>
);

ImagePlaceHolder.propTypes = {
  hidden: PropTypes.bool.isRequired,
};

const ActiveGalileoCard = ({ url, onError }) => {
  const { t: translate } = useTranslation();
  const [imageLoading, setImageLoading] = useState(true);

  function rendered() {
    // Render complete
    setImageLoading(false);
  }

  function startRender() {
    // Rendering start
    requestAnimationFrame(rendered);
  }

  function loaded() {
    requestAnimationFrame(startRender);
  }
  const _onError = useCallback(
    (e) => {
      setImageLoading(true);
      onError(e);
    },
    [onError]
  );

  return (
    <div className="py-4">
      <ImagePlaceHolder hidden={!imageLoading} />
      <img
        className="rounded img-fluid"
        hidden={imageLoading}
        style={{ pointerEvents: 'none' }}
        src={url}
        onError={_onError}
        alt={translate('card_galileo_image_title')}
        onLoad={loaded}
      />
    </div>
  );
};
export default ActiveGalileoCard;

ActiveGalileoCard.propTypes = {
  url: PropTypes.string,
  onError: PropTypes.func.isRequired,
};
ActiveGalileoCard.defaultProps = {
  url: null,
};
